import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fullWindow"]

  connect() {
    this.fullWindowTargets.forEach((target) => {
      target.style.height = (parseInt(window.innerHeight) - 32) + "px"
    })
  }
}
